import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { datadogRum } from '@datadog/browser-rum';

// Initialize Datadog RUM
// Debug: Check if environment variables are present
console.log('[Datadog] Environment check:', {
  hasAppId: !!process.env.REACT_APP_DATADOG_APPLICATION_ID,
  hasClientToken: !!process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
  appIdPrefix: process.env.REACT_APP_DATADOG_APPLICATION_ID?.substring(0, 8) + '...',
  site: process.env.REACT_APP_DATADOG_SITE,
  service: process.env.REACT_APP_DATADOG_SERVICE,
  env: process.env.REACT_APP_DATADOG_ENV || process.env.NODE_ENV,
});

if (process.env.REACT_APP_DATADOG_APPLICATION_ID && process.env.REACT_APP_DATADOG_CLIENT_TOKEN) {
  console.log('[Datadog] Initializing RUM...');
  datadogRum.init({
    applicationId: process.env.REACT_APP_DATADOG_APPLICATION_ID,
    clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
    site: (process.env.REACT_APP_DATADOG_SITE || 'datadoghq.com') as 'datadoghq.com',
    service: process.env.REACT_APP_DATADOG_SERVICE || 's4-product-matrix',
    env: process.env.REACT_APP_DATADOG_ENV || process.env.NODE_ENV || 'development',
    version: '1.0.0',
    sessionSampleRate: 100, // Track 100% of sessions
    sessionReplaySampleRate: 20, // Record 20% of sessions for replay (cost savings)
    trackUserInteractions: true, // Automatically track clicks
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input', // Privacy: mask user input in session replays
  });

  datadogRum.startSessionReplayRecording();
  console.log('[Datadog] RUM initialized successfully');
} else {
  console.warn('[Datadog] Skipping initialization - missing required environment variables');
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
